import Image from 'next/image';

type NextCategoryTileProps = {
  alt: string;
  image: string;
  square?: boolean;
};
export const NextCategoryTileImg = (props: NextCategoryTileProps): JSX.Element => {
  const { image, alt, square = false } = props;
  const squareProps = square ? { height: 128, width: 128, layout: 'responsive' as const } : {};

  return (
    <Image
      src={image}
      alt={alt}
      layout="fill"
      {...squareProps}
      sizes="(max-width: 768px) 128px, (max-width: 1024px) 160px, 220px"
      objectFit="cover"
    />
  );
};
